
import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import $ from 'jquery';
var Config: any = require('../../Config.json');
interface ResetPasswordState {
    resetpasswordFilters: ResetPasswordFields;
}

export class ResetPasswordWindow extends React.Component<any, ResetPasswordState> {
    constructor(props: any) {
        super(props);

        var filterSet = new ResetPasswordFields();
        filterSet.UserName = this.props.userName;
        this.state = { resetpasswordFilters: filterSet };
    }

    OldPasswordChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.resetpasswordFilters;
        var Value: string = event.currentTarget.value;
        filters.OldPassword = Value;
        this.setState({
            resetpasswordFilters: filters
        });
    }

    NewPasswordChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.resetpasswordFilters;
        var Value: string = event.currentTarget.value;
        filters.NewPassword = Value;
        this.setState({
            resetpasswordFilters: filters
        });
    }

    ConfirmPasswordChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.resetpasswordFilters;
        var Value: string = event.currentTarget.value;
        filters.ConfirmPassword = Value;
        this.setState({
            resetpasswordFilters: filters
        });
    }

    closeReset() {
        this.props.disableResetWindow();
        //$("#resetPasswordModel").css("display", "none");
    }

    componentDidMount() {
        $(document).ready(function () {
            $('button_Resetlogin').bind('keypress', function (e) {
                if (e.keyCode === 13) {
                    $('#button_Resetlogin').trigger('click');
                }
            });
        });
    }

    SavePassword() {
        $("#myModal").css("display", "block");
        $('#globalLoader').show();
        var filterParams = JSON.stringify(this.state.resetpasswordFilters);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl +'/api/AuthUser/ResetPassword', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<string>)
            .then(data => {
                $('#globalLoader').hide();
                if (data != "null") {
                    if (data == "Success") {
                        this.props.disableResetPassword();
                        PopupWindow.showErrorMessage("Confirmation", "Your password has been successfully changed. Please login with your new password.");
                        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                    }
                    else
                        PopupWindow.showErrorMessage("Error", data);
                    $(".mm-popup__box__body").css("white-space", "pre-line");
                }
            });
    }

    public render() {
       
        return <div>
            <div className="row mt-2">
                <div className="col-md-4 text-sm-end pe-0">
                    <span className='col-form-label mandatory-label'>Old Password :</span>
                </div>
                <div className="col-md-6">
                    <div className='input-group'>
                        <input type='password' id='txtOldPassword' className='form-control' placeholder='Old Password' onChange={e => this.OldPasswordChange(e)} value={this.state.resetpasswordFilters.OldPassword} />
                    </div>
                </div>
            </div>
   
           <div className="row mt-2">
                <div className="col-md-4 text-sm-end pe-0" >
                    <span className='col-form-label mandatory-label'>New Password :</span>
                </div>
                <div className="col-md-6">
                    <div className='input-group'>
                        <input type='password' id='txtNewPassword' className='form-control' placeholder='New Password' onChange={e => this.NewPasswordChange(e)} value={this.state.resetpasswordFilters.NewPassword} />
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-4 text-sm-end pe-0" >
                    <span className='col-form-label mandatory-label'>Confirm Password :</span>
                </div>
                <div className="col-md-6">
                    <div className='input-group'>
                        <input type='password' id='txtConfirmPassword' className='form-control' placeholder='Confirm Password' onChange={e => this.ConfirmPasswordChange(e)} value={this.state.resetpasswordFilters.ConfirmPassword} />
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className='mt-3 font-weight-bold ms-3'>Password requirements:</div>
                <ul className="password-text">
                    <li>Password must be at least eight (8) characters in length</li>
                    <li>Password must contain at least three (3) of the following:</li>
                    <ul className="dot">
                        <li>Uppercase letter (A-Z)</li>
                        <li>Lowercase letter (a-z)</li>
                        <li>Number (0-9)</li>
                        <li>Special character {"(\"~`!@#$%^&*()+=|\\{}':;.,<>/?[]_-)"}</li>
                    </ul>
                </ul>
            </div>
            <div className="modal-footer mt-3">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closeReset.bind(this)}>Cancel</button>
                <button type="button" id="button_Resetlogin" className="btn btn-primary" onClick={this.SavePassword.bind(this)}>Save</button>
                
            </div>
        </div>;
    }
}
class ResetPasswordFields {
    OldPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
    UserName: string;
}